export const LOAD_ORGANISATION = 'LOAD_ORGANISATION';
